var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('Header',[_c('template',{slot:"header-content"},[_vm._t("header-content")],2)],2),_c('div',{attrs:{"id":"body"}},[_vm._t("body"),_c('AlertDialog')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }